module.exports = __webpack_public_path__ + "static/media/textsecuritydisc.c62232aa.eot";